import { DirectSalesAssetLine } from 'components/common/types/DirectSalesCampaign.types';
import { SolutionSummary } from 'components/common/types/SolutionSummary.types';

export const transformAssetList = (
  data: SolutionSummary,
): {
  campaign: {
    framesCount: number;
    impressionsCount: number;
    price: number;
  };
  lines: Record<string, DirectSalesAssetLine>;
} => {
  const assetLines = Object.entries(data.dealLines).reduce(
    (acc: Record<string, DirectSalesAssetLine>, [lineId, lineRecord]) => {
      acc[lineId] = {
        framesCount: lineRecord.assetCount,
        impressionsCount: lineRecord.impressions,
        assets: lineRecord.assetCount ? lineRecord.assets : [],
        missingAssets: lineRecord.missingAssets.map((asset) => ({ ...asset.metadata, availability: 'Missing' })),
      };

      return acc;
    },
    {},
  );

  return {
    campaign: {
      framesCount: data.assetCount,
      impressionsCount: data.impressions,
      price: data.price,
    },
    lines: assetLines,
  };
};
